import React from 'react';

const LeftHandSideMenuContext = React.createContext<{
  isSidebarMenuOpen: boolean;
  toggleSidebarMenu: (isOpen?: boolean) => void;
}>({
  isSidebarMenuOpen: false,
  toggleSidebarMenu: () => {},
});

export const LeftHandSideMenuProvider = (props: React.PropsWithChildren) => {
  const [isOpen, setIsOpen] = React.useState<boolean>(false);

  const toggleSidebarMenu = React.useCallback((isOpen?: boolean) => {
    if (isOpen === undefined) {
      setIsOpen((prev) => !prev);
      return;
    }

    setIsOpen(isOpen);
  }, []);

  const value = React.useMemo(
    () => ({
      isSidebarMenuOpen: isOpen,
      toggleSidebarMenu,
    }),
    [isOpen, toggleSidebarMenu],
  );

  return <LeftHandSideMenuContext.Provider value={value}>{props.children}</LeftHandSideMenuContext.Provider>;
};

export const useLeftHandSideMenu = () => React.useContext(LeftHandSideMenuContext);
